import { AxiosError } from 'axios';
import { UseFormSetError } from 'react-hook-form';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { Firm } from '../types/firm';
import { useFormMutation } from './use-form-mutation';

export type CreateFirmRequest = {
    name: string;
    teamSize?: string;
    primaryWork?: string;
};

async function createFirm(request: CreateFirmRequest): Promise<{ firm: Firm }> {
    const { data } = await api.post('/firms', request);
    return data;
}

export function useCreateFirm(
    setError?: UseFormSetError<CreateFirmRequest>
): UseMutationResult<{ firm: Firm }, AxiosError, CreateFirmRequest, unknown> {
    return useFormMutation(createFirm, setError);
}
